






















































import Vue from 'vue';
import { MASS } from '@/mass/models/Mass';
import massClient from '../../apis';

const rights: string | undefined = undefined;
const code: string | undefined = undefined;

export default Vue.extend({
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    type: {
      type: Number,
      default: MASS.SEND_TYPE.MASS,
    },
    isTiming: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showAdminVerifyBox: false,
      verifyText: '',
      rights,
      MASS,
      admins: [],
      selectedIndex: 0,
      defaultAvatar: '',
      defaultNickname: '未知用户',
      isSending: false,
      sendingText: '',
      hasSend: false,
      confirm: false,
      sendLoading: false,
      code,
      loaded: false,
    };
  },
  computed: {
    verifyTitle() {
      let title = '';
      switch (this.type) {
        case MASS.SEND_TYPE.MASS:
          title = '公众号群发';
          this.verifyText = '为保证公众号群发信息的安全性，在公众号群发时需要管理验证，公众号群发权限管理员最多可设置三位。';
          this.rights = 'broadcast';
          break;
        case MASS.SEND_TYPE.BROADCAST:
          title = '广播';
          this.verifyText = '为保证广播信息的安全性，在广播时需要管理验证，广播权限管理员最多可设置三位。';
          this.rights = 'broadcasts';
          break;
        case MASS.SEND_TYPE.TEMPLATE:
          title = '模板群发';
          this.verifyText = '为保证模板群发信息的安全性，在模板群发时需要管理验证，模板群发权限管理员最多可设置三位。';
          this.rights = 'templateSend';
          break;
        case MASS.SEND_TYPE.SMS:
          title = '短信';
          this.verifyText = '为保证短信群发信息的安全性，在短信群发时需要管理验证，短信群发管理员最多可设置三位。';
          this.rights = 'sms';
          break;
        default: break;
      }
      return title;
    },
    sendType(): number {
      switch (this.isTiming) {
        case true: 
          return MASS.SEND_TYPE.TIMING_OUT_SEND;
        default:
          return this.type;
      }
    },
  },
  methods: {
    getHelperAuths() {
      massClient.getHelperByRights({
        rights: this.rights,
      }).success((r) => {
        this.admins = r.data;
        this.loaded = true;
      }).done(() => {
        this.loaded = true;
      });
    },
    confirmVerifyCode() {
      if (this.code !== undefined) {
        this.sendLoading = true;
        massClient.verifyCode({
          openid: (this.admins[this.selectedIndex] as any).customer.openid,
          sendType: this.sendType,
          code: this.code,
        }).success((r) => {
          if (r.code === 0) {
            this.confirm = true;
            const name = (this.admins[this.selectedIndex] as any).customer.realName ? (this.admins[this.selectedIndex] as any).customer.realName : (this.admins[this.selectedIndex] as any).customer.wxProps.nickname;
            this.$emit('confirm', {openid: (this.admins[this.selectedIndex] as any).customer.openid, name: name});
          } else {
            this.$Message.error('验证码错误');
            this.sendLoading = false;
          }
        }).error((e) => {
          this.$Message.error(e.toString());
          this.sendLoading = false;
        });
      } else {
        this.$Message.error('请输入验证码');
        this.sendLoading = false;
      }
    },
    sendVerifyCode() {
      if (!this.isSending) {
        this.isSending = true;
        this.sendingText = '';
        massClient.sendVerifyCode({
          openid: (this.admins[this.selectedIndex] as any).customer.openid,
          sendType: this.sendType,
        }).success((r) => {
          this.countDown(30);
        }).error((e) => {
          this.$Message.error(e.toString());
          this.isSending = false;
        });
      }
    },
    countDown(remain: number) {
      this.hasSend = true;
      const downCountInterval = setInterval(() => {
        remain -= 1;
        if (remain <= 0 || this.confirm) {
          clearInterval(downCountInterval);
          this.isSending = false;
        } else {
          this.sendingText = '验证码已发送，' + remain + 's后可重发';
        }
      }, 1000);
    },
    getImgUrl(customer: any) {
      if (customer) {
        return customer.wxProps.headimgurl.replace('http://', 'https://');
      } else {
        return this.defaultAvatar;
      }
    },
    getNickname(customer: any) {
      if (customer) {
        return customer.wxProps.nickname;
      } else {
        return this.defaultNickname;
      }
    },
    init() {
      this.isSending = false;
      this.hasSend = false;
      this.code = undefined;
      this.sendingText = '';
      this.confirm = false;
      this.sendLoading = false;
    },
    close() {
      this.init();
      this.$emit('close');
    },
  },
  mounted() {
    this.showAdminVerifyBox = this.show;
    this.init();
  },
  watch: {
    show() {
      this.showAdminVerifyBox = this.show;
      this.init();
    },
    rights() {
      this.getHelperAuths();
    },
  },
});
